import { createContext, type PropsWithChildren, useContext, useEffect, useMemo } from 'react'
import { type IChatbotFullData } from 'entities/Chatbot'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { DetailsStore } from './detailsStore'

const DetailsContext = createContext<DetailsStore | null>(null)

export const useDetailsContext = () => {
  const context = useContext(DetailsContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with DetailsContext')

  return context
}

export const DetailsProvider = ({
  data,
  children,
}: PropsWithChildren<{ data: IChatbotFullData }>) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new DetailsStore(data, entities), [])

  useEffect(() => () => store.dispose(), [])

  return <DetailsContext.Provider value={store}>{children}</DetailsContext.Provider>
}
